<template>
  <el-card style="width: 100%">
    <div
      slot="header"
      class="clearfix"
    >
      <span>Piros Mogyorós kimutatás</span>
    </div>
    <div class="filter-container">
      <el-form
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="20" style="display: flex; ">
            <el-form-item
              label="Dátum"
            >
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="dateRangeOptions"
                style="margin-right: 10px;"
                @change="fetchData"
              />
            </el-form-item>

            <el-form-item
              label="Termék"
              style="padding-right: 10px;"
            >
              <el-select
                v-model="product"
                filterable
                remote
                :remote-method="searchProduct"
                :loading="productLoading"
                placeholder="Gépelj a kereséshez..."
                style="width: 100%;"
                value-key="id"
                @change="fetchData"
                clearable
              >
                <el-option
                  v-for="p in products"
                  :key="p.id"
                  :value="p"
                  :label="p.name"
                />
              </el-select>
            </el-form-item>

            <el-form-item
              label="Terület"
            >
              <el-select
                v-model="location_id"
                style="width: 100%;"
                @change="fetchData"
                clearable
              >
                <el-option
                  v-for="location in locations"
                  :label="location.value"
                  :value="location.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item
              label="Vevő"
              style="padding-right: 10px;"
            >
              <el-select
                v-model="partner"
                filterable
                remote
                :remote-method="searchPartner"
                :loading="partnerLoading"
                placeholder="Gépelj a kereséshez..."
                style="width: 100%;"
                value-key="id"
                @change="fetchData"
                clearable
              >
                <el-option
                  v-for="p in partners"
                  :key="p.company.id"
                  :value="p"
                  :label="p.company.name"
                />
              </el-select>
            </el-form-item>

            <el-form-item
              label="Képviselő"
              style="padding-right: 10px;"
            >
              <el-select
                v-model="representativeUserId"
                v-loading="userLoading"
                filterable
                clearable
                @change="fetchData"
              >
                <el-option
                  v-for="user in representativeUsers"
                  :key="user.id"
                  :value="user.id"
                  :label="user.full_name"
                />
              </el-select>
            </el-form-item>

            <el-col :span="6" style="display: flex;
    align-items: center;
    height: 80px;">
              <el-checkbox-group v-model="types"                 @change="fetchData"
              >
                <el-checkbox label="representative" value="plus">Képviselői</el-checkbox>
                <el-checkbox label="central" value="minus">Központi</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-col>
          <el-col :span="4">
            <div style="text-align: right; margin-top: 24px;">
              <el-button
                :loading="downloadLoading"
                icon="el-icon-download"
                @click="download"
              >
                Letöltés
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div v-loading="loading">
      <el-table
        :data="data.items"
        style="width: 100%"
        row-key="id"
        border
      >
        <el-table-column
          prop="name"
          label="Vevő"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.partner_name }}
          </template>
        </el-table-column>

        <el-table-column
          prop="name"
          label="Termék"
          show-overflow-tooltip

        >
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>

        <el-table-column
          prop="name"
          label="Képviselő"
          show-overflow-tooltip

        >
          <template slot-scope="scope">
            {{ scope.row.creator_user_name }}
          </template>
        </el-table-column>

        <el-table-column
          prop="count"
          label="Darab"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="sum"
          label="Nettó összeg"
          width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.sum | currency }}
          </template>
        </el-table-column>

      </el-table>
    </div>
  </el-card>
</template>

<script>
  import moment from 'moment';
  import {saveAs} from 'file-saver';


  export default {
    components: {},
    data() {
      const start = moment()
        .startOf('year')
        .format('Y-MM-DD');
      const end = moment()
        .format('Y-MM-DD');
      return {
        location_id: null,
        partnerLoading: false,
        productLoading: false,
        product: null,
        products: [],
        partner: null,
        partners: [],
        location_id: null,
        representativeUserId: null,
        representativeUsers: [],
        userLoading: false,
        data: {},
        loading: false,
        downloadLoading: false,
        userLoading: false,
        dateRange: [start, end],
        types: ['representative', 'central'],
        dateRangeOptions: {
          firstDayOfWeek: 1,
          shortcuts: [{
            text: 'Aktuális hét',
            onClick(picker) {
              const start = moment()
                .weekday(1)
                .toDate();
              const end = moment()
                .weekday(7)
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hét',
            onClick(picker) {
              const start = moment()
                .subtract({weeks: 1})
                .weekday(1)
                .toDate();
              const end = moment()
                .subtract({weeks: 1})
                .weekday(7)
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális hónap',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .toDate();
              const end = moment()
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hónap',
            onClick(picker) {
              const start = moment()
                .subtract({months: 1})
                .startOf('month')
                .toDate();
              const end = moment()
                .subtract({months: 1})
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző 3 hónap',
            onClick(picker) {
              const start = moment()
                .subtract({months: 3})
                .startOf('month')
                .toDate();
              const end = moment()
                .subtract({months: 1})
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális év',
            onClick(picker) {
              const start = moment()
                .startOf('year')
                .toDate();
              const end = moment()
                .endOf('year')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző év',
            onClick(picker) {
              const start = moment()
                .subtract({years: 1})
                .startOf('year')
                .toDate();
              const end = moment()
                .subtract({years: 1})
                .endOf('year')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'YTD',
            onClick(picker) {
              const start = moment()
                .startOf('year')
                .toDate();
              const end = moment()
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'MTD',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .toDate();
              const end = moment()
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      };
    },
    computed: {
      locations() {
        return this.$store.getters['location/locations'];
      },
    },
    watch: {},
    async mounted() {
      this.fetchData();
    },
    methods: {
      async download() {
        this.downloadLoading = true;
        try {
          const excel = await axios({
            url: `api/reports/piros-mogyoros/download`,
            method: 'POST',
            responseType: 'blob',
            data: {
              from: this.dateRange[0],
              to: this.dateRange[1],
              partner_id: this.partner ? this.partner.id : null,
              product_id: this.product ? this.product.id : null,
              user_id: this.representativeUserId,
              types: this.types.join(),
              location_id: this.location_id,
            },
          });
          saveAs(excel, `pirosmogyoros.xlsx`);
        } catch (e) {
        }
        this.downloadLoading = false;
      },

      async fetchData() {
        this.loading = true;
        let query = `api/reports/piros-mogyoros?from=${this.dateRange[0]}&to=${this.dateRange[1]}`

        if (this.partner) {
          query += '&partner_id=' + this.partner.id;
        }

        if (this.location_id) {
          query += '&location_id=' + this.location_id;
        }

        if (this.product) {
          query += '&product_id=' + this.product.id;
        }

        if (this.representativeUserId) {
          query += '&user_id=' + this.representativeUserId;
        }

        query += '&types=' + this.types.join();


        this.data = await axios.get(query);
        this.loading = false;
      },

      async searchPartner(query) {
        if (query !== '') {
          this.partnerLoading = true;
          this.partners = await this.$store.dispatch('partner/search', '?name=' + query + '&is_supplier=true');
          this.partnerLoading = false;
        }
      },

      async searchProduct(query) {
        if (query !== '') {
          this.productLoading = true;
          this.products = await this.$store.dispatch('product/search', '?name=' + query);
          this.productLoading = false;
        }
      },
    },

    async mounted() {
      this.$store.dispatch('location/fetchAll');
      this.userLoading = true;
      try {
        this.representativeUsers = await axios.get('api/users/representatives');
      } catch (e) {}
      this.userLoading = false;
      this.fetchData();
    }
  };
</script>
<style lang="scss">
  .stockValue-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
